import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import api from "./api";

// Full worker/driver profile — same endpoint the web worker profile uses.
// `id` is the workers table id (resolve it from user_id via workerdashboardcount).
export async function workerdetail(id, fdate, tdate) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    const from = fdate || new Date().toISOString().split("T")[0];
    const to = tdate || new Date().toISOString().split("T")[0];
    return await api.get(`/viewworker/${id}/${from}/${to}`, { headers: header }).then((r) => r.data).catch((e) => Catcherror(e));
  } catch (e) { Catcherror(e); }
}

// Resolves the logged-in worker/driver (by user_id) to their worker record,
// which carries the workers.id needed to call workerdetail / viewworker.
export async function workerdashboardcount(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post(`/workercounts`, data, { headers: header }).then((r) => r.data).catch((e) => Catcherror(e));
  } catch (e) { Catcherror(e); }
}

export async function salaryRegister(data) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.post("/salaryregister", data, { headers: header }).then((r) => r.data).catch((e) => Catcherror(e));
  } catch (e) { Catcherror(e); }
}

export async function getPayslip(id) {
  try {
    const header = { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "multipart/form-data" };
    return await api.get(`/payslip/${id}`, { headers: header }).then((r) => r.data).catch((e) => Catcherror(e));
  } catch (e) { Catcherror(e); }
}

export async function stusubjectlist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .post(`/subjectlist`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}
export async function tokensave(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api.post(`/savedevicetoken`,data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function noticount() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/notificationcount`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

//Academy User Detail
export async function academyusergetdetail(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .get(`/user-details/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}
export async function studentdashboardcount(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/studentcounts`,data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function studentdetail(id,fdate,tdate) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/viewstudent/${id}/${fdate}/${tdate}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}
export async function studentview(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/viewdetailstudent/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function teacherview(id) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      };
      return await api
        .get(`/viewdetailteacher/${id}`, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          Catcherror(error);
        });
    } catch (error) {
      Catcherror(error);
    }
  }
  export async function teacherdetail(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/viewteacher/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}
export async function studentlistAttendance(fdate,tdate,cls,aca,user) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .get(`/studentlistattendance/${fdate}/${tdate}/${cls}/${aca}/${user}`, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          Catcherror(error);
        });
    } catch (error) {
      Catcherror(error);
    }
  }

  export async function listhomework(data) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      };
      return await api
        .post(`/homeworklist`,data, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          Catcherror(error);
        });
    } catch (error) {
      Catcherror(error);
    }
  }


  export async function notilist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/notificationlist`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}
export async function notistatus(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/notificationstatus/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function pushnotilist(type) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/pushnotificationlist/${type}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function pushnotistatus(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/pushnotificationstatus/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function stuclasslist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .get(`/classlist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function studivisionlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .get(`/divisionlist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function stuacademicyearlist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .post(`/academicyearlist`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function examtitlelist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .post(`/examlist`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function studentfilter(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/searchstudent`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function examstudentlist(id, aid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/liststudentexam/${id}/${aid}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function studentmarkcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/createstudentmark`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function studentmarklist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/liststudentmark`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function createhomework(data) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      };
      return await api
        .post(`/homeworksave`,data, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          Catcherror(error);
        });
    } catch (error) {
      Catcherror(error);
    }
  }
export async function academydetail(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/school/edit/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function slotslist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .post(`/listslots`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function teacherdashboardcount(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/teachercounts`,data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}
export async function listtimetabledet(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/listtimetable`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function listAttendance(data) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .post(`/studentattendance`,data, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          Catcherror(error);
        });
    } catch (error) {
      Catcherror(error);
    }
  }

  export async function addAttendance(data) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .post(`/markattendance`,data, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          Catcherror(error);
        });
    } catch (error) {
      Catcherror(error);
    }
  }
export async function listAllClassAttendance(date,tdate,cls,aca,rle) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .get(`/listattendance/${date}/${tdate}/${cls}/${aca}/${rle}`, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          Catcherror(error);
        });
    } catch (error) {
      Catcherror(error);
    }
  }

  export async function studentlist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/allstudents/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function teacherlist(id) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      };
      return await api
        .get(`/allteacher/${id}`, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          Catcherror(error);
        });
    } catch (error) {
      Catcherror(error);
    }
  }

  export async function leavecountdashboard(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/leavedashboard`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function leavelist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/listleave`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function leaveapply(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/createleave`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function listcompbook(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/listcomplaint`,data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function detailcompbook(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .get(`/viewcomplaint/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function createcompbook(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/createcomplaint`,data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}


export async function listevent(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/eventlist`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function feedashboardcount(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/feedashboardcount`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function feeinvoicelist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/feeinvoice`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function transportattendancelist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/driverattendancelist`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function listvehicle(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/vehiclelist`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function listvehiclewise(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/vehiclewiselist`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function vehtriplist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .post(`/vehicletriplist`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function vehroutelist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await api
      .post(`/vehicleroutelist`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function vehicledriverattendance(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/driverattendance`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function vehicleLocationUpdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/vehiclelocationupdate`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function vehicleLocationLatest(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/vehiclelocationlatest`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function transportpushcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/transportattendancepush`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => { Catcherror(error); });
  } catch (error) {
    Catcherror(error);
  }
}

export async function studentreportcard(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/studentreportcard`,data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}
export async function updateprofilephoto(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/updateprofilephoto`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}

export async function pushcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await api
      .post(`/pushnotificationcreate`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        Catcherror(error);
      });
  } catch (error) {
    Catcherror(error);
  }
}
function Catcherror(error) {
  if (error.response.status === 401 || error.response.status === 422) {
    localStorage.clear();
    <Link to={"/login"}></Link>

  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    console.log("Error", error.message);
  }
}
